import React from "react";

export function Spinner({ size = 28, color = "#10b981", className = "" }) {
  return (
    <div
      className={`inline-block animate-spin rounded-full border-2 border-current border-t-transparent ${className}`}
      style={{ width: size, height: size, color }}
      role="status"
      aria-label="Loading"
    />
  );
}

export function LoadingBlock({ message = "Loading…", color = "#10b981" }) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Spinner size={36} color={color} />
      <p className="text-[#6b7280] text-sm mt-3">{message}</p>
    </div>
  );
}

export function Logo({ size = 18, withSquare = true }) {
  return (
    <span style={{ fontSize: size, letterSpacing: 4, fontWeight: 800 }} className="select-none">
      <span className="text-white">BREAK</span>
      <span style={{ color: "#c8ff00" }}>POINT</span>
      {withSquare && <span style={{ color: "#c8ff00", fontSize: size * 0.6 }}> ■</span>}
    </span>
  );
}

export default Spinner;
